import actions from "@/store/modules/user-system/actions";
import mutations from "@/store/modules/user-system/mutations";
import state from "@/store/modules/user-system/state";

export default {
    actions,
    mutations,
    state
}